import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useGetOpportunity } from '@/lib/api/opportunities';
import { toOpportunityFormData } from '@/features/opportunities/form/utils';
import OpportunityPreview from '@/features/opportunities/OpportunityPreview.tsx';
import { GoogleMapsProvider } from '@/context/GoogleMapsProvider';

interface PreviewOpportunityModalProps {
  open: boolean;
  onClose: () => void;
  opportunityId: string;
}

const PreviewOpportunityModal: React.FC<PreviewOpportunityModalProps> = ({
  open,
  onClose,
  opportunityId,
}) => {
  const { data: opportunity } = useGetOpportunity(opportunityId);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          height: '90vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Previsualización de Oportunidad
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, overflow: 'auto' }}>
        {opportunity && (
          <GoogleMapsProvider>
            <Box sx={{ p: 2 }}>
              <OpportunityPreview
                data={toOpportunityFormData(opportunity)}
                opportunityId={opportunityId}
                mainImageId={opportunity.mainImageId}
              />
            </Box>
          </GoogleMapsProvider>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PreviewOpportunityModal;
